export const formatDateTime = (dateTime: Date) => {
  const date = new Date(dateTime);
  const optionsDate: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };

  const optionsTime: Intl.DateTimeFormatOptions = {
    timeZoneName: 'short',
    hour: '2-digit',
    minute: '2-digit',
  };

  const optionsTimeZone: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
    timeZoneName: 'short',
  };

  const optionsTimeFullDate: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
    hour12: false,
  };

  const optionsDayAndMonth: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: '2-digit',
  };

  const customFormattedDate: string = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);

  const formattedDayAndMonth = date.toLocaleString('en-GB', optionsDayAndMonth);
  const formattedDate = date.toLocaleString('en-GB', optionsDate);
  const formattedTime = date.toLocaleString('en-GB', optionsTime);
  const formattedTimeZone = date.toLocaleString('en-GB', optionsTimeZone);
  const formattedFullDate = date.toLocaleString('en-GB', optionsTimeFullDate);

  return {
    fullDate: `${formattedFullDate}`,
    formattedDate: `${customFormattedDate}`,
    date: `${formattedDate}`,
    time: `${formattedTime}`,
    timeWithZone: `${formattedTimeZone}`,
    formattedDayAndMonth: `${formattedDayAndMonth}`,
    rawDate: Intl.DateTimeFormat('en-GB', optionsTimeFullDate),
  };
};
